import React from 'react';

export const BasketSvg = ({ fill = '#000' }) => (
  <svg
    fill={fill}
    width="20px"
    height="20px"
    viewBox="0 -1.5 27 27"
    xmlns="http://www.w3.org/2000/svg">
    <path d="m25.714 10.286h.027c.465 0 .885.192 1.185.502.31.301.502.721.502 1.186v.028-.001.027c0 .465-.192.885-.502 1.185-.301.31-.721.502-1.186.502-.009 0-.019 0-.028 0h.001-.201l-1.541 8.869c-.069.413-.283.767-.587 1.015l-.003.002c-.29.249-.67.401-1.085.401-.004 0-.008 0-.013 0h-17.142c-.004 0-.008 0-.012 0-.415 0-.795-.152-1.087-.403l.002.002c-.307-.251-.52-.604-.588-1.008l-.001-.01-1.541-8.869h-.201c-.008 0-.017 0-.027 0-.465 0-.885-.192-1.185-.502-.31-.301-.502-.721-.502-1.186 0-.009 0-.019 0-.028v.001c0-.008 0-.017 0-.027 0-.465.192-.885.502-1.185.301-.31.721-.502 1.186-.502h.028-.001zm-19.223 10.714c.236-.017.442-.13.581-.3l.001-.001c.131-.146.211-.339.211-.552 0-.025-.001-.05-.003-.074v.003l-.429-5.572c-.017-.236-.13-.442-.3-.581l-.001-.001c-.146-.131-.339-.211-.552-.211-.025 0-.05.001-.074.003h.003c-.236.017-.442.13-.581.3l-.001.001c-.131.146-.211.339-.211.552 0 .025.001.05.003.074v-.003l.429 5.572c.015.224.118.422.274.562l.001.001c.149.141.35.228.572.228h.011-.001zm5.505-.856v-5.572c0-.002 0-.005 0-.008 0-.234-.097-.445-.254-.594-.15-.157-.361-.254-.595-.254-.003 0-.005 0-.008 0-.002 0-.005 0-.008 0-.234 0-.445.097-.594.254-.157.15-.254.361-.254.595v.008 5.572.008c0 .234.097.445.254.594.15.157.361.254.595.254h.008.008c.234 0 .445-.097.594-.254.159-.15.258-.363.258-.598 0-.002 0-.004 0-.006zm5.143 0v-5.572c0-.002 0-.005 0-.008 0-.234-.097-.445-.254-.594-.15-.157-.361-.254-.595-.254-.003 0-.005 0-.008 0-.002 0-.005 0-.008 0-.234 0-.445.097-.594.254-.157.15-.254.361-.254.595v.008 5.572.008c0 .234.097.445.254.594.15.157.361.254.595.254h.008.008c.234 0 .445-.097.594-.254.159-.15.258-.363.258-.598 0-.002 0-.004 0-.006zm4.714.066.429-5.572c.002-.021.003-.046.003-.071 0-.212-.08-.406-.211-.553l.001.001c-.141-.172-.347-.285-.58-.302h-.003c-.021-.002-.046-.003-.071-.003-.212 0-.406.08-.553.211l.001-.001c-.172.141-.285.347-.302.58v.003l-.429 5.572c-.002.021-.003.046-.003.071 0 .212.08.406.211.553l-.001-.001c.141.172.347.285.58.302h.003.067.01c.222 0 .423-.087.573-.228.159-.141.263-.34.279-.564v-.003zm-15.478-16.3-1.245 5.518h-1.768l1.352-5.906c.163-.785.59-1.45 1.182-1.915l.007-.005c.571-.464 1.306-.744 2.107-.744h.038-.002 2.236c0-.002 0-.005 0-.008 0-.234.097-.445.254-.594.15-.157.361-.255.596-.255h.012 5.142.008c.234 0 .445.097.594.254.157.15.254.361.254.595v.008h2.236.037c.801 0 1.536.28 2.112.748l-.006-.005c.599.47 1.025 1.135 1.185 1.899l.004.021 1.352 5.906h-1.768l-1.245-5.518c-.095-.392-.312-.724-.606-.962l-.003-.003c-.282-.233-.647-.375-1.046-.375-.007 0-.014 0-.02 0h-2.235v.008c0 .234-.097.445-.254.594-.15.157-.361.254-.595.254-.003 0-.005 0-.008 0h-5.142c-.002 0-.005 0-.008 0-.234 0-.445-.097-.594-.254-.157-.15-.254-.361-.254-.595 0-.003 0-.005 0-.008h-2.236c-.006 0-.013 0-.019 0-.398 0-.764.142-1.048.377l.003-.002c-.297.242-.512.574-.603.954l-.002.012z" />
  </svg>
);
export const ArrowBottomSvg = () => (
  <svg
    width="35px"
    height="35px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 9.5L12 14.5L7 9.5"
      stroke="#fff"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ListSvg = () => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M2 3.75A.75.75 0 012.75 3h.5a.75.75 0 010 1.5h-.5A.75.75 0 012 3.75zm4 0A.75.75 0 016.75 3h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 016 3.75zm-4 4A.75.75 0 012.75 7h.5a.75.75 0 010 1.5h-.5A.75.75 0 012 7.75zm4 0A.75.75 0 016.75 7h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 016 7.75zm-4 4a.75.75 0 01.75-.75h.5a.75.75 0 010 1.5h-.5a.75.75 0 01-.75-.75zm4 0a.75.75 0 01.75-.75h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75z"
      clipRule="evenodd"
    />
  </svg>
);
export const SettingSvg = () => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7517 4.69329C13.7517 3.85839 13.1416 3.14883 12.3161 3.0238C12.1066 2.99207 11.8935 2.99207 11.6839 3.0238C10.8584 3.14883 10.2482 3.85839 10.2482 4.6933V5.87397C9.77662 6.00858 9.32734 6.19618 8.90726 6.42992L8.07205 5.59471C7.48168 5.00435 6.54849 4.93407 5.87637 5.42937C5.70578 5.55509 5.55509 5.70578 5.42937 5.87637C4.93407 6.54849 5.00434 7.4817 5.59471 8.07207L6.42992 8.90728C6.19617 9.32735 6.00857 9.77663 5.87397 10.2483H4.6933C3.85839 10.2483 3.14883 10.8584 3.0238 11.6839C2.99207 11.8935 2.99207 12.1066 3.0238 12.3161C3.14883 13.1416 3.85839 13.7518 4.69329 13.7518H5.87396C6.00857 14.2234 6.19617 14.6727 6.42992 15.0927L5.59471 15.9279C5.00434 16.5183 4.93407 17.4515 5.42937 18.1236C5.55509 18.2942 5.70578 18.4449 5.87638 18.5706C6.5485 19.0659 7.48169 18.9957 8.07205 18.4053L8.90726 17.5701C9.32734 17.8038 9.77662 17.9914 10.2482 18.126V19.3067C10.2482 20.1416 10.8584 20.8512 11.6839 20.9762C11.8934 21.0079 12.1066 21.0079 12.3161 20.9762C13.1416 20.8512 13.7517 20.1416 13.7517 19.3067V18.1261C14.2234 17.9914 14.6727 17.8038 15.0927 17.5701L15.9279 18.4053C16.5183 18.9957 17.4515 19.0659 18.1236 18.5706C18.2942 18.4449 18.4449 18.2942 18.5706 18.1236C19.0659 17.4515 18.9957 16.5183 18.4053 15.928L17.5701 15.0928C17.8038 14.6727 17.9914 14.2234 18.1261 13.7518H19.3067C20.1416 13.7518 20.8512 13.1416 20.9762 12.3161C21.0079 12.1066 21.0079 11.8935 20.9762 11.6839C20.8512 10.8584 20.1416 10.2483 19.3067 10.2483H18.126C17.9914 9.77662 17.8038 9.32734 17.5701 8.90726L18.4053 8.07205C18.9957 7.48168 19.0659 6.54849 18.5706 5.87637C18.4449 5.70578 18.2942 5.55509 18.1236 5.42937C17.4515 4.93407 16.5183 5.00434 15.9279 5.59471L15.0927 6.42992C14.6727 6.19617 14.2234 6.00857 13.7517 5.87396V4.69329Z"
      fill="#ccc"
      fillOpacity={0.15}
      stroke="#ccc"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12Z"
      stroke="#ccc"
      strokeWidth={1.5}
    />
  </svg>
);
export const DownloadSvg = () => (
  <svg width="15px" height="15px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#000000"
      fillRule="evenodd"
      d="M14,9 C14.5523,9 15,9.44772 15,10 L15,13 C15,14.1046 14.1046,15 13,15 L3,15 C1.89543,15 1,14.1046 1,13 L1,10 C1,9.44772 1.44772,9 2,9 C2.55228,9 3,9.44771 3,10 L3,13 L13,13 L13,10 C13,9.44771 13.4477,9 14,9 Z M8,1 C8.55228,1 9,1.44772 9,2 L9,6.58579 L10.2929,5.29289 C10.6834,4.90237 11.3166,4.90237 11.7071,5.29289 C12.0976,5.68342 12.0976,6.31658 11.7071,6.70711 L8,10.4142 L4.29289,6.70711 C3.90237,6.31658 3.90237,5.68342 4.29289,5.29289 C4.68342,4.90237 5.31658,4.90237 5.70711,5.29289 L7,6.58579 L7,2 C7,1.44772 7.44772,1 8,1 Z"
    />
  </svg>
);
export const CopySvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#000000"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round">
    <rect x={9} y={9} width={13} height={13} rx={2} ry={2} />
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </svg>
);

export const PlateSvg = ({ fill = '#a5d254' }) => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 302.459 302.46"
    style={{
      enableBackground: 'new 0 0 302.459 302.46',
    }}
    xmlSpace="preserve"
    fill={fill}>
    <g>
      <g>
        <path d="M163.816,222.91c38.745,0,70.269-31.514,70.269-70.259c0-38.745-31.523-70.274-70.269-70.274 c-38.743,0-70.264,31.524-70.264,70.274C93.552,191.396,125.068,222.91,163.816,222.91z" />
        <path d="M163.816,241.771c49.226,0,89.118-39.903,89.118-89.119c0-49.228-39.893-89.123-89.118-89.123 c-49.221,0-89.119,39.895-89.119,89.123C74.697,201.867,114.595,241.771,163.816,241.771z M163.816,77.183 c41.608,0,75.469,33.862,75.469,75.469c0,41.609-33.86,75.464-75.469,75.464c-41.609,0-75.464-33.854-75.464-75.464 C88.352,111.045,122.207,77.183,163.816,77.183z" />
        <path d="M302.459,250.062l-5.2-200.026c0-4.307-3.493-7.8-7.8-7.8c-1.152,0-2.234,0.264-3.214,0.718v-0.074 c0,0-0.203,0.13-0.493,0.328c-0.746,0.412-1.416,0.919-1.995,1.539c-5.708,4.685-23.907,23.78-25.431,49.592 c-2.311,39.372,16.813,55.317,23.328,69.921l-5.199,85.798c0,4.306,8.693,7.8,12.999,7.8 C293.766,257.862,302.459,254.369,302.459,250.062z" />
        <path d="M13.614,128.206l13.461,6.724c1.534,0.769,3.225,1.33,4.992,1.747l-5.2,117.007c0,3.615,8.696,6.54,13,6.54 c4.306,0,13-2.925,13-6.54l-5.2-117.606c1.831-0.576,3.595-1.279,5.139-2.224l9.973-6.073c7.196-4.39,12.619-14.045,12.619-22.475 V52.88c0-4.307-3.494-7.8-7.8-7.8c-4.304,0-7.8,3.493-7.8,7.8v47.225h-4.332V52.88c0-4.307-3.494-7.8-7.8-7.8 c-4.304,0-7.8,3.493-7.8,7.8v47.225h-4.347V52.88c0-4.307-3.494-7.8-7.8-7.8c-4.304,0-7.8,3.493-7.8,7.8v47.225H15.6V54.565 c0-4.306-3.494-7.8-7.8-7.8c-4.304,0-7.8,3.494-7.8,7.8v51.612C0,114.852,5.855,124.327,13.614,128.206z" />
      </g>
    </g>
  </svg>
);
export const CloseSvg = ({ fill = '#fff' }) => (
  <svg width="30px" height="30px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M11.2929,3.29289 C11.6834,2.90237 12.3166,2.90237 12.7071,3.29289 C13.0976,3.68342 13.0976,4.31658 12.7071,4.70711 L9.41421,8 L12.7071,11.2929 C13.0976,11.6834 13.0976,12.3166 12.7071,12.7071 C12.3166,13.0976 11.6834,13.0976 11.2929,12.7071 L8,9.41421 L4.70711,12.7071 C4.31658,13.0976 3.68342,13.0976 3.29289,12.7071 C2.90237,12.3166 2.90237,11.6834 3.29289,11.2929 L6.58579,8 L3.29289,4.70711 C2.90237,4.31658 2.90237,3.68342 3.29289,3.29289 C3.68342,2.90237 4.31658,2.90237 4.70711,3.29289 L8,6.58579 L11.2929,3.29289 Z"
    />
  </svg>
);
export const ReverseSvg = ({ fill = '#000' }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512.002 512.002"
    style={{
      enableBackground: 'new 0 0 512.002 512.002',
    }}
    xmlSpace="preserve"
    width="25px"
    height="25px"
    fill={fill}>
    <g>
      <g>
        <path d="M362.668,128.004H26.608c-12.382,0-23.757,8.346-26.112,20.497c-3.174,16.341,9.318,30.703,25.105,30.703h337.067 c2.355,0,4.267-1.911,4.267-4.267v-42.667C366.935,129.916,365.023,128.004,362.668,128.004z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M508.98,147.085L398.047,53.218c-2.534-2.142-6.084-2.628-9.105-1.229c-3.012,1.408-4.941,4.42-4.941,7.748v187.733 c0,3.328,1.929,6.34,4.941,7.74c1.152,0.538,2.372,0.794,3.593,0.794c1.98,0,3.942-0.691,5.513-2.014l110.933-93.867 c1.92-1.63,3.021-4.011,3.021-6.519S510.9,148.715,508.98,147.085z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M123.06,256.798c-3.021-1.399-6.571-0.913-9.105,1.229L3.022,351.893c-1.92,1.621-3.021,4.002-3.021,6.511 s1.101,4.89,3.021,6.519l110.933,93.867c1.57,1.323,3.533,2.014,5.513,2.014c1.22,0,2.441-0.256,3.593-0.794 c3.012-1.399,4.941-4.412,4.941-7.74V264.538C128.001,261.21,126.073,258.197,123.06,256.798z" />
      </g>
    </g>
    <g>
      <g>
        <path d="M511.506,353.301c-2.364-12.151-13.739-20.497-26.112-20.497h-336.06c-2.355,0-4.267,1.911-4.267,4.267v42.667 c0,2.355,1.911,4.267,4.267,4.267h337.067C502.188,384.004,514.681,369.643,511.506,353.301z" />
      </g>
    </g>
  </svg>
);

export const TapClickSvg = ({ fill = '#000' }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="30px"
    height="30px"
    viewBox="0 0 511.448 511.448"
    style={{
      enableBackground: 'new 0 0 511.448 511.448',
    }}
    xmlSpace="preserve">
    <g>
      <path
        style={{
          fill: '#FFFFFF',
        }}
        d="M282.788,114.33c0,37.204-21.364,71.117-54.127,87.498v-21.662 c21.916-14.559,35.348-39.358,35.348-65.836c0-43.556-35.437-78.982-78.982-78.982s-78.982,35.426-78.982,78.982 c0,26.478,13.432,51.277,35.348,65.836v21.662c-32.764-16.382-54.127-50.294-54.127-87.498c0-53.906,43.854-97.761,97.761-97.761 S282.788,60.424,282.788,114.33z"
      />
      <path
        style={{
          fill: '#FFFFFF',
        }}
        d="M424.182,257.248v157.544c0,44.163-35.923,80.086-80.086,80.086H213.373 c-34.52,0-65.063-22.004-75.977-54.757l-31.394-94.204c-5.015-15.045,0.287-31.339,13.189-40.562l22.203-15.863v72.277 c0,4.573,3.712,8.285,8.285,8.285s8.285-3.712,8.285-8.285V114.33c0-7.611,3.226-14.913,8.87-20.027 c5.7-5.192,13.123-7.644,20.877-6.904c13.675,1.303,24.379,13.797,24.379,28.455v175.218c0,4.573,3.712,8.285,8.285,8.285 s8.285-3.712,8.285-8.285V238.05c0-7.611,3.226-14.913,8.87-20.027c5.7-5.192,13.123-7.655,20.877-6.904 c13.675,1.303,24.379,13.797,24.379,28.455v7.313v53.023c0,4.573,3.712,8.285,8.285,8.285c4.573,0,8.285-3.712,8.285-8.285v-53.023 c0-7.611,3.226-14.913,8.87-20.027c5.7-5.192,13.123-7.655,20.877-6.904c13.675,1.303,24.379,13.797,24.379,28.455v7.313v53.023 c0,4.573,3.712,8.285,8.285,8.285s8.285-3.712,8.285-8.285v-53.023c0-7.611,3.226-14.913,8.87-20.027 c5.7-5.192,13.123-7.655,20.877-6.904C413.478,230.096,424.182,242.59,424.182,257.248z"
      />
    </g>
    <path
      style={{
        fill: '#C2E95D',
      }}
      d="M247.44,114.33c0,16.934-6.948,32.985-18.779,44.594v-43.07c0-23.109-17.299-42.849-39.38-44.959 c-12.271-1.16-24.522,2.894-33.603,11.146c-9.08,8.252-14.283,20.027-14.283,32.289v44.594 c-11.831-11.61-18.779-27.671-18.779-44.594c0-34.409,28.003-62.412,62.412-62.412S247.44,79.921,247.44,114.33z"
    />
    <path
      style={{
        fill: '#535757',
      }}
      d="M440.751,257.248v157.544c0,53.299-43.357,96.656-96.656,96.656H213.373 c-41.667,0-78.518-26.556-91.696-66.091l-31.394-94.193c-7.336-21.993,0.42-45.82,19.275-59.286l31.836-22.744v-49.101 C98.92,202.48,70.696,160.581,70.696,114.33C70.696,51.288,121.985,0,185.026,0s114.33,51.288,114.33,114.33 c0,31.04-12.725,60.114-33.923,81.191c12.239,2.861,22.524,11.212,28.456,22.292c1.005-1.127,2.066-2.198,3.181-3.214 c9.081-8.252,21.332-12.306,33.603-11.146c14.604,1.392,27.12,10.505,33.912,23.197c1.005-1.127,2.066-2.198,3.181-3.214 c9.081-8.252,21.332-12.306,33.603-11.146C423.453,214.399,440.751,234.139,440.751,257.248z M424.182,414.792V257.248 c0-14.659-10.704-27.152-24.379-28.455c-7.755-0.751-15.177,1.712-20.877,6.904c-5.645,5.114-8.87,12.416-8.87,20.027v53.023 c0,4.573-3.712,8.285-8.285,8.285s-8.285-3.712-8.285-8.285v-53.023v-7.313c0-14.659-10.704-27.152-24.379-28.455 c-7.755-0.751-15.177,1.712-20.877,6.904c-5.645,5.114-8.87,12.416-8.87,20.027v53.023c0,4.573-3.712,8.285-8.285,8.285 c-4.573,0-8.285-3.712-8.285-8.285v-53.023v-7.313c0-14.659-10.704-27.152-24.379-28.455c-7.755-0.751-15.177,1.712-20.877,6.904 c-5.645,5.114-8.87,12.416-8.87,20.027v53.023c0,4.573-3.712,8.285-8.285,8.285c-4.573,0-8.285-3.712-8.285-8.285V115.855 c0-14.659-10.704-27.152-24.379-28.455c-7.755-0.74-15.177,1.712-20.877,6.904c-5.645,5.114-8.87,12.416-8.87,20.027v247.439 c0,4.573-3.712,8.285-8.285,8.285c-4.573,0-8.285-3.712-8.285-8.285v-72.277l-22.203,15.863 c-12.903,9.224-18.204,25.517-13.189,40.562l31.394,94.204c10.914,32.753,41.457,54.757,75.977,54.757H344.1 C388.259,494.878,424.182,458.955,424.182,414.792z M228.661,201.829c32.764-16.382,54.127-50.294,54.127-87.498 c0-53.906-43.854-97.761-97.761-97.761S87.267,60.424,87.267,114.33c0,37.204,21.364,71.117,54.127,87.498v-21.662 c-21.916-14.559-35.348-39.358-35.348-65.836c0-43.556,35.437-78.982,78.982-78.982s78.982,35.426,78.982,78.982 c0,26.478-13.432,51.277-35.348,65.836V201.829z M228.661,158.924c11.831-11.61,18.779-27.66,18.779-44.594 c0-34.409-28.003-62.412-62.412-62.412s-62.412,28.003-62.412,62.412c0,16.923,6.948,32.985,18.779,44.594V114.33 c0-12.261,5.203-24.037,14.283-32.289c9.081-8.252,21.332-12.306,33.603-11.146c22.082,2.11,39.38,21.85,39.38,44.959V158.924z"
    />
  </svg>
);
